export default "/recording/_next/static/images/icon-sprite.0de6474173070bf1b870aef17df394eb.svg";